import { nextPlaybackRate } from '@/lib/playbackRate'
import { FC } from 'react'

export interface PlaybackSpeedButtonProps {
  playbackRate: number
  onPlaybackRateChange: (rate: number) => void
}

const PlaybackSpeedButton: FC<PlaybackSpeedButtonProps> = ({ playbackRate, onPlaybackRateChange }) => {
  const handleClick = () => {
    onPlaybackRateChange(nextPlaybackRate(playbackRate))
  }

  return (
    <button
      onClick={handleClick}
      className="w-[36px] h-[36px] bg-black/50 backdrop-blur-sm text-white rounded-full hover:bg-black/70 transition-colors flex items-center justify-center text-[14px] font-medium"
    >
      {playbackRate}x
    </button>
  )
}

export default PlaybackSpeedButton
